(() => {
  const initReviewsGrid = () => {
    document.querySelectorAll('.community-modal').forEach((modal) => {
      if (modal.dataset.rgReady) return;
      modal.dataset.rgReady = 'true';

      const items = Array.from((modal.closest('section') || document).querySelectorAll('.community-gallery__item'));
      if (!items.length) return;

      const modalImg = modal.querySelector('.community-modal__image');
      const modalText = modal.querySelector('.community-modal__text');
      const modalAuthor = modal.querySelector('.community-modal__author');
      const thumbsContainer = modal.querySelector('.community-modal__thumbnails');
      const closeBtn = modal.querySelector('.community-modal__close');
      const overlay = modal.querySelector('.community-modal__overlay');
      const leftArrow = modal.querySelector('.thumb-arrow.left');
      const rightArrow = modal.querySelector('.thumb-arrow.right');
      const isMobile = () => window.innerWidth < 750;
      let activeIndex = 0;

      function updateArrows() {
        leftArrow.style.display = activeIndex > 0 ? 'flex' : 'none';
        rightArrow.style.display = activeIndex < items.length - 1 ? 'flex' : 'none';
      }

      function centerActive(smooth) {
        const thumbs = thumbsContainer.querySelectorAll('.community-modal__thumb');
        const t = thumbs[activeIndex];
        if (t) t.scrollIntoView({ behavior: smooth ? 'smooth' : 'instant', inline: 'center', block: 'nearest' });
      }

      function setActive(index, smooth) {
        if (index < 0 || index >= items.length) return;
        activeIndex = index;
        const item = items[index];
        if (modalImg) modalImg.src = item.dataset.image;
        modalText.textContent = item.dataset.text;
        modalAuthor.textContent = item.dataset.author;
        thumbsContainer.querySelectorAll('.community-modal__thumb').forEach((t, i) => {
          t.classList.toggle('active', i === index);
        });
        centerActive(smooth);
        updateArrows();
      }

      function buildThumbs() {
        thumbsContainer.innerHTML = '';
        items.forEach((item, i) => {
          const thumb = document.createElement('div');
          thumb.className = 'community-modal__thumb';
          const img = document.createElement('img');
          img.src = item.dataset.image;
          img.addEventListener('load', () => {
            if (modal.classList.contains('active')) centerActive(false);
          }, { once: true });
          thumb.appendChild(img);
          thumb.addEventListener('click', () => setActive(i, true));
          thumbsContainer.appendChild(thumb);
        });
      }

      function openModal(index) {
        if (!isMobile()) return;
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
        buildThumbs();
        requestAnimationFrame(() => setActive(index, false));
      }

      function closeModal() {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }

      items.forEach((item, index) => {
        item.addEventListener('click', () => openModal(index));
      });
      leftArrow.addEventListener('click', () => setActive(activeIndex - 1, true));
      rightArrow.addEventListener('click', () => setActive(activeIndex + 1, true));
      closeBtn.addEventListener('click', closeModal);
      overlay.addEventListener('click', closeModal);
    });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', initReviewsGrid) : initReviewsGrid();
})();